import Button from '@mui/material/Button';
import { Style } from './Styles.jsx';

const BottomToolBar = (props) => {
  const { menu, buttons } = props;
  // El espacio antes del menu (col-"col", mas abajo) tiene que calcularse con la
  // cantidad de botones que de verdad se van a DIBUJAR (button.auth truthy), no con
  // buttons.length: algunos botones (p.ej. "Registrar" en ProviderInvoiceShow) solo
  // aparecen bajo cierta condicion, y buttons.length cuenta la entrada del arreglo
  // aunque ese boton no se renderice. Si se usa buttons.length, cuando un boton
  // condicional queda oculto la fila suma menos de 12 columnas en total y el icono
  // del menu deja de quedar pegado a la derecha.
  let visibleButtonsCount = buttons ? buttons.filter((button) => button.auth).length : 0;
  let col = 11 - visibleButtonsCount * 2;
  return (
    <div class="row" style={{ marginTop: '1.2em' }}>
      {buttons && buttons.map((button, index) => {
        return button.auth && (
          <div class="col-2" key={index}>
            <Button
              style={index % 2 === 0 ? Style.SaveButton : Style.DeleteButton}
              onClick={button.action}
              disabled={props.disabled}>
              {button.name}
            </Button>
          </div>
        )
      })}
      <div class={"col-" + col}></div>
      {menu && (
        <div class="col-1">
          {menu}
        </div>
      )}
    </div>
  )
};

export default BottomToolBar;